import type { ReactNode } from 'react';

type InsightsHeroProps = {
  variant: 'events' | 'publications';
  eyebrow: string;
  title: string;
  subtitle?: string;
  children?: ReactNode;
};

export default function InsightsHero({ variant, eyebrow, title, subtitle, children }: InsightsHeroProps) {
  return (
    <section className={`insights-hero insights-hero--${variant}`}>
      <div className="insights-hero__inner">
        <div className="insights-hero__content">
          <p className="insights-hero__eyebrow">{eyebrow}</p>
          <h1 className="insights-hero__title">{title}</h1>
          {subtitle ? <p className="insights-hero__subtitle">{subtitle}</p> : null}
          {children ? <div className="insights-hero__controls">{children}</div> : null}
        </div>
      </div>
    </section>
  );
}
